import actionConsts from './../../constants/actions';
import orderBy from 'lodash/orderBy';

const mailThreads = (state = [], action = {}) => {
    let { payload } = action;
    let newState;
    switch (action.type) {
        case actionConsts.RECEIVE_INIT_DATA:
            return state;

        case actionConsts.SET_MAILS:

        case actionConsts.RESTART_TUTORIAL: return []

        case actionConsts.ADD_SHOW_CALL_FLAG:
            let callObject = {
                id: payload.call.id,
                expectedAtTime: payload.expectedAtTime,
                type: payload.type
            }
            newState = [...state, callObject]

            return orderBy(newState, ['expectedAtTime'], ['desc'])

        case actionConsts.ADD_SHOW_MEETING_FLAG:
            let meetingObject = {
                id: payload.meeting.id,
                expectedAtTime: payload.expectedAtTime,
                type: payload.type
            }
            newState = [...state, meetingObject]
            return orderBy(newState, ['expectedAtTime'], ['desc'])

        default: return state;
    }
}

export default mailThreads;


// WEBPACK FOOTER //
// /src/reducers/callSequence/index.js